module Meevo.Components.Interceptors {
  angular.module("meevo.components.interceptors", []);
}